<template>
  <div id="app">
    <router-view></router-view>

    <div id="mxc-captcha-element"></div>
    <div id="mxc-captcha-button"></div>
  </div>
</template>

<script>
export default {
  name: 'Page1',
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/activities/index.vue